import React from 'react';
import {
  Create,

  TextInput,
  NumberInput,
  ArrayInput,
  SimpleFormIterator,
  PasswordInput,
  required,
  email,
  minLength,
  TabbedForm,
  FormTab,
} from 'react-admin';

const validateEmail = [required(), email()];
const validatePassword = [required(), minLength(6)];
const validateName = [required()];

export const UserCreate = () => (
  <Create>
    <TabbedForm>
      <FormTab label="Основная информация">
        <TextInput source="name" validate={validateName} label="Имя" />
        <TextInput source="email" validate={validateEmail} label="Email" />
        <PasswordInput source="password" validate={validatePassword} label="Пароль" />
        <NumberInput source="age" label="Возраст" />
        <TextInput source="profession" label="Профессия" />
        <TextInput source="company" label="Компания" />
        <TextInput source="location" label="Местоположение" />
        <TextInput source="phone" label="Телефон" />
        <TextInput source="bio" multiline rows={3} label="Био" />
      </FormTab>

      <FormTab label="Навыки">
        <ArrayInput source="skills" label="Навыки">
          <SimpleFormIterator>
            <TextInput source="" label="Навык" />
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>

      <FormTab label="Доставка">
        <TextInput source="shippingCountry" label="Страна" />
        <TextInput source="shippingCity" label="Город" />
        <TextInput source="shippingAddress" label="Адрес" />
        <TextInput source="shippingZipCode" label="Индекс" />
        <TextInput source="shippingNotes" multiline rows={2} label="Примечания" />
      </FormTab>
    </TabbedForm>
  </Create>
);
